module.exports = __webpack_public_path__ + "img/icon-search-dark.c31b3dfa.svg";